module.exports = __webpack_public_path__ + "static/media/icon_money.a5fd539b.svg";